import { Reveal, SectionHeading } from "./Reveal";
import { IMAGES, PHONE_DISPLAY, PHONE_TEL } from "../../lib/site";
import { useLang } from "../../lib/i18n";

export const About = () => {
    const { t } = useLang();
    return (
    <section id="over-ons" data-testid="about-section" className="relative bg-night-900/40 py-24 sm:py-32">
        <div className="container-x grid items-center gap-14 lg:grid-cols-5 lg:gap-20">
            <div className="lg:col-span-3">
                <SectionHeading
                    num="06"
                    eyebrow={t.about.eyebrow}
                    title={t.about.title}
                />
                <Reveal delay={0.2}>
                    <div className="mt-7 space-y-5 text-base leading-relaxed text-slate-400 sm:text-lg" data-testid="about-text">
                        <p>{t.about.p1}</p>
                        <p>{t.about.p2}</p>
                    </div>
                </Reveal>
                <Reveal delay={0.3}>
                    <div className="mt-10 grid grid-cols-3 gap-4" data-testid="about-facts">
                        {t.about.facts.map((fact) => (
                            <div key={fact.label} className="rounded-xl border border-white/8 bg-night-850/70 px-4 py-5 text-center sm:text-left">
                                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">{fact.label}</p>
                                <p className="mt-2 font-display font-wide text-xl font-extrabold uppercase text-amber-400 sm:text-2xl">
                                    {fact.value}
                                </p>
                            </div>
                        ))}
                    </div>
                </Reveal>
                <Reveal delay={0.35}>
                    <a href={PHONE_TEL} data-testid="about-call-cta" className="mt-9 inline-flex items-center gap-3 text-slate-300 transition-colors hover:text-amber-300">
                        <span className="text-sm">{t.about.callCta}</span>
                        <span className="font-mono text-lg font-bold tracking-wider text-white">{PHONE_DISPLAY}</span>
                    </a>
                </Reveal>
            </div>
            <Reveal delay={0.15} className="lg:col-span-2">
                <div className="relative">
                    <div className="absolute -inset-3 rounded-3xl bg-gradient-to-tr from-amber-400/15 to-transparent blur-xl" />
                    <img
                        src={IMAGES.interior}
                        alt={t.about.alt}
                        className="relative aspect-[3/4] w-full rounded-3xl border border-white/10 object-cover shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9)]"
                        data-testid="about-image"
                    />
                </div>
            </Reveal>
        </div>
    </section>
    );
};
